/** Official Bulandi 2026 participants group (same as Apps Script `BULANDI_OFFICIAL_WHATSAPP_GROUP_URL`). */
export const BULANDI_OFFICIAL_WHATSAPP_GROUP_URL =
  "https://chat.whatsapp.com/GZhPZLxrRNJIH6kgfux9d7?mode=gi_t";
